import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthRoutes, MESSAGE_QUERY_PARAM, AuthMessages } from '../constants/auth.constants';

/**
 * Centralizes auth-related navigation so guards and components use the same routes and messages.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthNavigationService {
  constructor(private router: Router) {}

  navigateToHome(): void {
    this.router.navigate([AuthRoutes.home]);
  }

  navigateToNotAuthorized(message?: string): void {
    const queryParams = message ? { [MESSAGE_QUERY_PARAM]: message } : undefined;
    this.router.navigate([AuthRoutes.notAuthorized], queryParams ? { queryParams } : undefined);
  }

  navigateToNotAuthorizedPermissions(): void {
    this.navigateToNotAuthorized(AuthMessages.requiredPermissions);
  }

  navigateToNotAuthorizedNoTenants(): void {
    this.navigateToNotAuthorized(AuthMessages.noTenants);
  }

  navigateToAssociationSelection(): void {
    this.router.navigate([AuthRoutes.associationSelection]);
  }

  navigateToFlaggedContacts(): void {
    this.router.navigate([AuthRoutes.flaggedContacts]);
  }
}
